import { updateConsent } from "./ga";
import { checkIfInIframe } from "./iframe";

const concept3dDomainRegex = /.*\.?concept3d\.com$/;

export const addPostMessageListener = (callback, once = false) => {
  if (!checkIfInIframe() || typeof callback !== 'function') return;
  window.addEventListener('message', (event) => {
    if (!concept3dDomainRegex.test(event.origin)) return;
    callback(event.data);
  }, {
    once,
  });
};

export const addGtagConsentListener = (callback) => {
  addPostMessageListener(handleGtagConsent(callback), true);
}

export const handleGtagConsent = (callback) => (data) => {
  if (data && data.gtagConsent) {
    const { gtagConsent } = data;
    updateConsent(gtagConsent);
    typeof callback === 'function' && callback(gtagConsent);
  }
}